import {FC, useState} from "react";
import {Dialog, DialogTitle} from "@mui/material";
import {urlApiData, urlApiDataCRGCI} from "../helper/api";
import {CustomModalAuth} from "../ui/CustomModal";
import FullScreenSpinner from "../ui/FullScreenSpinner";
import {Spinner} from "react-bootstrap";

export interface AuthRequest {
  identifier: string;
  password: string;
}

export interface User {
  id: number;
  documentId: string;
  username: string;
  email: string;
  provider: string;
  confirmed: boolean;
  blocked: boolean;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export interface AuthResponse {
  jwt: string;
  user: User;
}

export interface AuthError {
  error?: {
    message: string;
  };
}

interface IProps {
  isOpenAuthModal: boolean;
  onCloseModal: () => void;
}

export const AuthPage: FC<IProps> = ({isOpenAuthModal, onCloseModal}) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const requestBody: AuthRequest = {
        identifier: login,
        password: password,
      };
      const response = await fetch(`${urlApiDataCRGCI}/api/auth/local`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data: AuthResponse | AuthError = await response.json();

      if ("jwt" in data && data.jwt) {
        localStorage.setItem("jwtRadar", data.jwt);
        localStorage.setItem("roleRadar", data.user.username);
        localStorage.setItem("userIdRadar", data.user.documentId);
        window.dispatchEvent(new CustomEvent("authChanged"));
        onCloseModal();
      } else {
        const errorData = data as AuthError;
        const errorMessage =
          errorData.error?.message ||
          "Ошибка авторизации. Попробуйте ещё раз или обратитесь к администратору.";
        setError(
          errorMessage === "Invalid identifier or password"
            ? "Неверный логин или пароль"
            : errorMessage
        );
      }
    } catch (err) {
      setError("Ошибка сети");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <CustomModalAuth
        title="Авторизация"
        isOpenAutModal={isOpenAuthModal}
        onCloseModal={onCloseModal}
      >
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "18px",
          }}
          onSubmit={async (e) => {
            e.preventDefault();
            handleLogin(e);
          }}
        >
          <input
            type="text"
            placeholder="Логин"
            style={{
              background: "#181b1f",
              color: "#fafafa",
              border: "1px solid #333",
              borderRadius: 6,
              padding: "12px",
              fontSize: 16,
              outline: "none",
            }}
            required
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            disabled={loading}
          />
          <input
            type="password"
            placeholder="Пароль"
            style={{
              background: "#181b1f",
              color: "#fafafa",
              border: "1px solid #333",
              borderRadius: 6,
              padding: "12px",
              fontSize: 16,
              outline: "none",
            }}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
          />
          {error && (
            <div style={{color: "#ff5252", fontSize: 14, marginTop: -8}}>
              {error}
            </div>
          )}
          <button
            type="submit"
            style={{
              background: "#3a3f44",
              color: "#fafafa",
              border: "none",
              borderRadius: 6,
              padding: "12px",
              fontSize: 16,
              cursor: "pointer",
              marginTop: "8px",
              fontWeight: 500,
              letterSpacing: 1,
            }}
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Войти"}
          </button>
        </form>
      </CustomModalAuth>
    </>
  );
};
